"use client";

import { oddsRangeText } from "../odds-range";

export function formatThresholdsSummary({
  minDataPoints,
  minLiquidity = 0,
  minEV,
  showMinEV,
  minOddsToHit,
  maxOddsToHit,
  minOdds = null,
  maxOdds = null,
  requiredBookCount,
}: {
  minDataPoints: number;
  minLiquidity?: number;
  minEV: number;
  showMinEV: boolean;
  minOddsToHit: number;
  maxOddsToHit: number;
  minOdds?: number | null;
  maxOdds?: number | null;
  requiredBookCount: number;
}): string {
  const parts: string[] = [];
  if (minDataPoints > 0) parts.push(`${minDataPoints} books`);
  if (minLiquidity > 0) parts.push(`$${minLiquidity}+ liquidity`);
  if (showMinEV && minEV > 0) parts.push(`${minEV}%+ EV`);
  if (minOddsToHit > 0 || maxOddsToHit < 100) parts.push(`${minOddsToHit}–${maxOddsToHit}%`);
  const oddsRange = oddsRangeText({ minOdds, maxOdds });
  if (oddsRange) parts.push(oddsRange);
  if (requiredBookCount > 0) parts.push(requiredBookCount === 1 ? "req book" : `${requiredBookCount} req books`);
  return parts.length > 0 ? parts.join(" · ") : "defaults";
}

export function clampOddsRangeUpdate(
  update: { minOddsToHit?: number; maxOddsToHit?: number },
  current: { min: number; max: number },
): { minOddsToHit?: number; maxOddsToHit?: number } {
  const next = { ...update };
  if (next.minOddsToHit != null && next.maxOddsToHit == null) {
    next.minOddsToHit = Math.min(next.minOddsToHit, current.max);
  }
  if (next.maxOddsToHit != null && next.minOddsToHit == null) {
    next.maxOddsToHit = Math.max(next.maxOddsToHit, current.min);
  }
  return next;
}
